export function buildSmoothSegment(lastRenderedPoint, previousPoint, point) {
  if (!lastRenderedPoint || !previousPoint || !point) return null;
  const middle = {
    x: (previousPoint.x + point.x) / 2,
    y: (previousPoint.y + point.y) / 2,
  };
  return {
    start: lastRenderedPoint,
    control: previousPoint,
    end: middle,
    nextRenderedPoint: middle,
    nextPoint: point,
  };
}

export function buildStrokeTail(lastRenderedPoint, finalPoint) {
  if (!lastRenderedPoint || !finalPoint) return null;
  if (lastRenderedPoint.x === finalPoint.x && lastRenderedPoint.y === finalPoint.y) return null;
  return { start: lastRenderedPoint, control: finalPoint, end: finalPoint };
}
